<template>
  <div class="hero">
    <div class="pic" v-if="pic">
      <img :src="pic" :alt="title">
    </div>
    <div class="bread">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hero{
  position: relative;
}
.pic{
  position: relative;
  padding: calc(100% / 16 * 4.4) 0 0;
  min-height: 20rem;
  margin: 6rem calc(#{module.side()} * 2) 0 0;
  @media screen and (max-width: module.$tab){
    margin-right: calc(#{module.side()} * 3);
  }
  @media screen and (max-width: module.$phone){
    min-height: 1px;
    height: 16rem;
    margin-top: 5.2rem;
  }
  img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0 .64rem .64rem 0;
  }
  div{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    color: module.$white;
    text-align: center;
    line-height: 1.5;
    font-weight: 700;
    p{
      font-size: 3.6rem;
    }
    h1{
      font-size: 1.12rem;
    }
  }
}
.bread{
  position: absolute;
  top: 0;
  right: module.side();
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    eng: {
      type: String,
      required: false
    },
    pic: {
      type: String,
      required: false
    },
  }
}
</script>
